<template>
  <v-row class="mt-2">
    <v-col cols="4" v-for="level in levels" :key="level.name">
      <v-card>
        <v-card-title>
          <v-row no-gutters>
            <v-col cols="6">
              <span class="text-subtitle-2">{{ level.name }}</span>
            </v-col>
            <v-col cols="6">
              <v-select
                v-model="level.selectedReference"
                :items="references"
                dense
                clearable
                hide-details
                item-text="name"
                return-object
                @change="saveReferenceSettings(level)"
              />
            </v-col>
          </v-row>
        </v-card-title>
        <v-card-text class="black--text text-caption">
          <v-row no-gutters>
            <v-col
              class=" d-flex align-start"
              :class="{
                'flex-column': level.selectedReference
              }"
            >
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Total Size</td>
                    <td><b>{{ level.total.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>MIN Room</td>
                    <td><b>{{ level.min.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>MAX Room</td>
                    <td><b>{{ level.max.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>AVG Room</td>
                    <td><b>{{ level.avg.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>Median Room</td>
                    <td><b>{{ level.median.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>Rooms quantity</td>
                    <td><b>{{ level.count }}</b></td>
                  </tr>
                </tbody>
              </table>
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Interactions (<b>{{ getTotalInteractions(level.name) }}</b>)</td>
                    <td><b>1 | {{ (level.total / getTotalInteractions(level.name)).toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <template v-for="category in sortCategories(level.items)">
                    <tr v-if="categories.event_area_calculation.some(c => c === category)" :key="category">
                      <td>{{ category }} (<b>{{ getTotal(level.items[category], 'actors') }}</b>)</td>
                      <td><b>1 | {{ (level.total / getTotal(level.items[category], 'actors')).toFixed(0) }} m<sup>2</sup></b></td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </v-col>
            <v-col v-if="level.selectedReference">
              <table width="100%">
                <tbody>
                  <tr>
                    <td>Total Size</td>
                    <td><b>{{ level.selectedReference.total_size.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>MIN Room</td>
                    <td><b>{{ level.selectedReference.min_room.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>MAX Room</td>
                    <td><b>{{ level.selectedReference.max_room.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>AVG Room</td>
                    <td><b>{{ level.selectedReference.avg_room.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>Median Room</td>
                    <td><b>{{ level.selectedReference.median_room.toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                  <tr>
                    <td>Rooms quantity</td>
                    <td><b>{{ level.selectedReference.rooms_quantity }}</b></td>
                  </tr>
                </tbody>
              </table>
              <table width="100%">
                <tbody>
                  <tr v-for="category in level.selectedReference.categories" :key="category.name">
                    <td>{{ category.name }} (<b>{{ category.value }}</b>)</td>
                    <td><b>1 | {{ (level.selectedReference.total_size / category.value).toFixed(0) }} m<sup>2</sup></b></td>
                  </tr>
                </tbody>
              </table>
            </v-col>
          </v-row>
          <v-expansion-panels
            class="stretched-panel"
            accordion
            flat
          >
            <v-expansion-panel>
              <v-expansion-panel-header>Details</v-expansion-panel-header>
              <v-expansion-panel-content>
                <table
                  v-for="category in sortCategories(level.items)"
                  :key="category"
                  width="100%"
                  class="items text-caption"
                >
                  <thead>
                    <tr>
                      <th :colspan="1 + (getKeys(level.items[category]).length * 2)">{{ category }}</th>
                    </tr>
                    <tr>
                      <th class="text-start">name</th>
                      <template v-for="key in getKeys(level.items[category])">
                        <th class="text-center" :key="key + '-amount-name'">{{ key }}</th>
                        <th class="text-center" :key="key + '-percent-name'">%</th>
                      </template>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in sortCategories(level.items[category])"
                      :key="item"
                    >
                      <td>{{ item }}</td>
                      <template v-for="key in sortCategories(level.items[category][item])">
                        <td class="text-center" :key="key + '-amount'">{{ level.items[category][item][key] }}</td>
                        <td class="text-center" :key="key + '-percent'">{{ getPersentage(level.items[category], key, level.items[category][item][key]) }}%</td>
                      </template>
                    </tr>
                    <tr>
                      <td>Total</td>
                      <template v-for="key in getKeys(level.items[category])">
                        <td class="text-center" :key="key + '-total-amount'">{{ getTotal(level.items[category], key) }}</td>
                        <td class="text-center" :key="key + '-total-percent'">100%</td>
                      </template>
                    </tr>
                  </tbody>
                </table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      categories: [],
      references: [],
      levels: []
    }
  },
  async mounted () {
    await this.getEditorCategories()
    await this.getReferences()
    await this.getStatistic()
  },
  computed: {
    referenceSettings: {
      get () {
        return this.$store.state.referenceSettings[this.$store.state.currProject.db] || []
      },
      set (val) {
        this.$store.dispatch('updateReferenceSettings', val)
      }
    },
  },
  watch: {
    async '$route.query' () {
      await this.getStatistic()
    }
  },
  methods: {
    async getEditorCategories () {
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/configs/editor/data', {
        params: {
          select: ['id', 'alias', 'combined_computin', 'event_area_calculation']
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.categories = data.reduce((categories, category) => {
          if (category.event_area_calculation) {
            categories.event_area_calculation.push(category.alias)
          }

          if (category.combined_computin) {
            categories.combined_computin.push(category.alias)
          }

          return categories
        }, {
          combined_computin: [],
          event_area_calculation: []
        })
      }
    },
    async getStatistic () {
      if (!this.$route.query.map_id) return

      this.loading = true
      const { data } = await this.$axios.get(this.$store.getters.projectPath + '/levels/statistic/' + this.$route.query.map_id, {
        params: {
          levels: this.$route.query.levels,
          revision: this.$route.query.revision
        }
      })
      .catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.levels = data.map(level => {
          const setting = this.referenceSettings.find(val => val[0] === level.name)

          if (!setting) { return level }

          const reference = this.references.find(val => val.name === setting[1])

          if (!reference) { return level }
          return {
            ...level,
            selectedReference: reference
          }
        })
      }
      this.loading = false
    },
    async getReferences () {
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/configs/levels-references`
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.references = data
      }
    },
    sortCategories (value) {
      if (Array.isArray(value)) {
        return value.sort((a, b) => {
          if (a.toLowerCase() > b.toLowerCase()) return 1
          if (a.toLowerCase() < b.toLowerCase()) return -1
          return 0
        })
      } else {
        return Object.keys(value).sort((a, b) => {
          if (a.toLowerCase() > b.toLowerCase()) return 1
          if (a.toLowerCase() < b.toLowerCase()) return -1
          return 0
        })
      }
    },
    getTotalInteractions (levelName) {
      return this.categories.combined_computin.reduce((total, category) => {
        const level = this.levels.find(val => val.name === levelName)
        if (level && level.items && level.items[category]) {
          return total + this.getTotal(level.items[category], 'actors')
        } else {
          return total
        }
      }, 0)
    },
    getTotal (category, key) {
      return Object.values(category).reduce((all, val) => all + val[key], 0)
    },
    getPersentage (category, key, itemValue) {
      const total = this.getTotal(category, key)
      if (total === 0) {
        return '0.00'
      } else {
        return (itemValue * 100 / total).toFixed(2)
      }
    },
    getKeys (category) {
      return  Object.values(category).reduce((keys, item) => {
        Object.keys(item).forEach(key => {
          if (!keys.includes(key)) {
            keys.push(key)
          }
        })
        return keys
      }, [])
    },
    saveReferenceSettings (level) {
      const setting = [level.name, level.selectedReference && level.selectedReference.name || null]
      const newVal = this.referenceSettings.filter(val =>
        val[0] !== setting[0]
      )
      newVal.push(setting)
      this.referenceSettings = newVal
    }
  }
}
</script>

<style scoped>
  .items {
    border-collapse: collapse;
  }

  .items tbody tr:not(:last-child),
  .items thead tr:last-child {
    border-bottom: 1px solid gray;
  }

  .stretched-panel >>> .v-expansion-panel-header,
  .stretched-panel >>> .v-expansion-panel-content__wrap {
    padding: 0;
  }
</style>